import { Validations } from '@/utils/Validations'
import { h } from 'vue'
import { VAutocomplete } from 'vuetify/lib'
import './InputBase.scss'
import InputLabel from './InputLabel'

interface AutoCompleteBasicoProps {
	props: {
		[prop: string]: any
	}
}

export const AutoCompleteBasico = VAutocomplete.extend({
	name: 'AutoCompleteBasico',
	extends: VAutocomplete,
	props: {
		outlined: { default: true },
		dense: { default: true },
		validateOnBlur: { default: true },
		autocomplete: { default: 'off' },
		labelName: { default: '', type: String },
		hint: { default: '', type: String },
		required: { default: false, type: Boolean },
		instructions: { default: '', type: String },
		persistentPlaceholder: { default: true },
		noRequiredText: { type: Boolean, default: false }
	},
	data: () => ({
		query: ''
	}),

	computed: {
		computedProps(): AutoCompleteBasicoProps {
			let props = {
				props: {
					...this.$props,
					hint: '',
					label: '',
					rules: [...this.$props.rules, this.isRequired ? Validations.isRequired : () => true],
					validateOnBlur: true
				}
			}

			return props
		},

		isRequired(): boolean {
			if (this.required) return true
			if (this.$props.rules) return this.$props.rules.includes(Validations.isRequired)

			return false
		},

		fieldName(): string {
			if ('name' in this.$props) return this.$props['name']
			return ''
		}
	},
	methods: {
		renderLabel() {
			if (!this.labelName || this.labelName == undefined) return <span />
			return (
				<InputLabel
					label={this.labelName}
					required={this.isRequired}
					instructions={this.instructions}
					hint={this.hint}
					noRequiredText={this.noRequiredText}
				/>
			)
		},

		handleFilterInput(value: string) {
			this.query = value
		},

		renderInput() {
			const listeners = Object.assign(this.listeners$, {
				'update:search-input': this.handleFilterInput
			}) as any

			return h(VAutocomplete, {
				class: 'my-2',
				ref: 'input',
				on: listeners,
				...this.computedProps,
				attrs: this.$attrs
			})
		}
	},
	render() {
		return h(
			'div',
			{
				class: 'd-flex flex-column app--input-base_wrapper'
			},
			[this.renderLabel(), this.renderInput()]
		)
	}
})

export default AutoCompleteBasico
